import EstadoModel  from '@/models/cadastros/assistencia/Estados'
import TipoEndereco from '@/models/cadastros/assistencia/TipoEndereco';

export default class  ServicoSubClienteModel {

    nomeSubCliente?: string;
    cpfCnpj?: string;
    email?: string;
    telefone?: string;
    cep?: string;
    tipoEndereco?: TipoEndereco;
    logradouro?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    estado?: EstadoModel;
}